import { useTranslation } from "react-i18next";
import { NewsletterLineup } from "./NewsletterLineup";
import { formatMatchDay } from "./newsletterFormat";

export function NewsletterUpcoming({ upcoming }) {
  const { t, i18n } = useTranslation();
  const league = upcoming?.league || [];
  const cup = upcoming?.cup || [];
  const events = upcoming?.tournaments || [];
  const day = (iso) => formatMatchDay(iso, i18n.language);

  return (
    <>
      {league.length || cup.length ? (
        <section className="pingflo-section">
          <h2>{t("newsletterNextMatches", "Next matches")}</h2>
          <ul className="pingflo-fixtures">
            {league.map((match) => (
              <li key={match.fixture_id}>
                <p className="pingflo-fixture-when">
                  {day(match.date)}
                  {match.time ? ` · ${match.time}` : ""} ·{" "}
                  {match.home ? t("newsletterHome", "home") : t("newsletterAway", "away")}
                  {match.division ? ` · ${match.division}` : ""}
                </p>
                <h3>
                  {match.team_name} <span className="pingflo-quiet">{t("newsletterVs", "vs")}</span>{" "}
                  {match.opponent_name}
                </h3>
                <NewsletterLineup lineup={match.lineup} />
              </li>
            ))}
            {cup.map((match) => (
              <li key={match.fixture_id || `${match.date}-${match.home_name}`}>
                <p className="pingflo-fixture-when">
                  {day(match.date)} · {match.cup_name || t("newsletterCup", "Cup")}
                  {match.round ? ` · ${match.round}` : ""}
                </p>
                <h3>
                  {match.home_name} <span className="pingflo-quiet">{t("newsletterVs", "vs")}</span>{" "}
                  {match.away_name}
                </h3>
                <NewsletterLineup lineup={match.lineup} />
              </li>
            ))}
          </ul>
        </section>
      ) : null}
      {events.length ? (
        <section className="pingflo-section">
          <h2>{t("newsletterComingEvents", "Coming tournaments")}</h2>
          <ul className="pingflo-fixtures">
            {events.map((event) => (
              <li key={event.tournament_id || `${event.event_date}-${event.name}`}>
                <p className="pingflo-fixture-when">
                  {day(event.event_date)}
                  {event.venue ? ` · ${event.venue}` : ""}
                </p>
                <h3>{event.name}</h3>
                {event.categories?.length ? (
                  <p className="pingflo-quiet">{event.categories.join(", ")}</p>
                ) : null}
                {event.participants?.length ? (
                  <p>
                    {t("newsletterRegistered", "Registered")}: {event.participants.join(", ")}
                  </p>
                ) : null}
                {event.url ? (
                  <a href={event.url} target="_blank" rel="noopener noreferrer">
                    {t("newsletterRegister", "Details and registration")}
                  </a>
                ) : null}
              </li>
            ))}
          </ul>
        </section>
      ) : null}
    </>
  );
}
